import { cn } from '@/lib/utils'
import { initials } from './peopleStats'

/** Initials tinted by who owes whom: green they owe you, orange you owe them, grey settled. */
export function PersonAvatar({
  name,
  net,
  size = 'md',
  className,
}: {
  name: string
  net: number
  size?: 'sm' | 'md' | 'lg'
  className?: string
}) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'grid shrink-0 place-items-center rounded-full font-semibold',
        size === 'sm' && 'h-9 w-9 text-[13px]',
        size === 'md' && 'h-10 w-10 text-sm',
        size === 'lg' && 'h-12 w-12 text-lg',
        net > 0 && 'bg-[var(--fl-primary-subtle)] text-[var(--fl-primary-text)]',
        net < 0 && 'bg-[var(--fl-expense-bg)] text-[var(--fl-expense)]',
        net === 0 && 'bg-[var(--fl-surface-subtle)] text-[var(--fl-text-2)]',
        className
      )}
    >
      {initials(name)}
    </span>
  )
}
